import React from "react"

import { contextPlaceholderFunction } from "@/lib/context/placeholderFunction"
import type { Notices } from "@/lib/notices"

export const NoticesContext = React.createContext<Notices.ContextData>({
  clearNotices: contextPlaceholderFunction,
  displayNotice: contextPlaceholderFunction,
  list: [],
  removeNotice: contextPlaceholderFunction,
})
